import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/routes/app-routes';
// import { t } from '@shared/pipes/translate.pipe';
import { MustMatch } from '@shared/validator';
import { AwsService, HelperService, TranslateService, UserProfileService } from '__services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-new-password',
  templateUrl: './new-password.component.html',
  styleUrls: ['./new-password.component.scss', '../login/login.component.scss'],
})
export class NewPasswordComponent implements OnInit, OnDestroy {
  // t = t;
  hide = true;
  isLoading = false;
  setPasswordForm: FormGroup;
  user: any;
  errorMsg = '';
  private destroy$: Subject<any> = new Subject();

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private awsService: AwsService,
    private userProfileService: UserProfileService,
        private trans: TranslateService,
  ) {
    this.setPasswordForm = this.fb.group(
      {
        password: ['', [Validators.required]],
        confirmPassword: [''],
      },
      {
        validators: MustMatch('password', 'confirmPassword'),
      }
    );
    // this.awsService.setNewPassword
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe((user) => {
    //     if (user) {
    //       this.user = user;
    //     } else {
    //       this.router.navigate([APP_ROUTES.LOGIN]);
    //     }
    //   });
  }

  get formControl(): any {
    return this.setPasswordForm.controls;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  setPassword(): void {
    this.setPasswordForm.markAllAsTouched();
    if (this.setPasswordForm.valid && !this.isLoading) {
      this.isLoading = true;
      this.awsService
        .confirmSignIn(this.formControl.password.value)
        .then(
          () => {
            this.awsService.callLogin().subscribe(
              (res) => {
                this.errorMsg = '';
                this.userProfileService.setUserFeature(res.role.modules)
                this.userProfileService.setUserProfile(res)
                // localStorage.setItem(
                //   'userFeatures',
                //   JSON.stringify(res.role.modules)
                // );
                // this.awsService.getInfoCognitoUser().then(
                //   (user) => {
                //     if (!user.attributes?.phone_number_verified) {
                //       this.awsService.confirmSMS.next(user);
                //       this.router.navigate([APP_ROUTES.NEW_PHONE]);
                //     } else
                //       this.router.navigate([APP_ROUTES.DASHBOARD], {
                //         replaceUrl: true,
                //       });
                //   },
                //   (err) => {
                //     SwalService.error(err.message);
                //   }
                // );
                this.router.navigate([APP_ROUTES.DASHBOARD], {
                  replaceUrl: true,
                });
              },
              (err) => {
                this.isLoading = false;
                this.errorMsg = err.message;
                this.router.navigate([APP_ROUTES.DASHBOARD], {
                  replaceUrl: true,
                });
              }
            );
          },
          (err) => {
            this.isLoading = false;
            this.errorMsg = err.message;
          }
        )
        .catch((err) => {
          this.errorMsg = err.message;
        }
      );
    }
  }

  getPasswordErrorMessage(): string {
    if (this.formControl.password.hasError('required')) {
      return this.trans.translate('You must enter a value');
    }
  }

  getConfirmPasswordErrorMessage(): string {
    if (this.formControl.confirmPassword.hasError('required')) {
      return this.trans.translate('You must enter a value');
    }
    if (
      this.formControl.password.value !== this.formControl.confirmPassword.value
    ) {
      return this.trans.translate('Confirm password not match');
    }
  }

  getToday(): string {
    return HelperService.getToday();
  }
}
